<div *ngIf="provider" class="provider-details-container">
  <h2>{{ provider.field_name }}</h2>
  <p><strong>Address:</strong> {{ provider.field_address_field_1 }}</p>
  <p><strong>Services:</strong></p>
  <div [innerHTML]="provider.field_service_provided"></div>
  <p><strong>Hours of Operation:</strong></p>
  <div [innerHTML]="provider.field_hours_of_operation"></div>
  <!-- Add more fields as needed -->
</div>